import { Component, Input, OnChanges } from '@angular/core'

import { Aggregation } from '../../../shared/interfaces/visualizations/aggregation.interface'
import { IncentiveFamily } from '../../../shared/enums/incentive.family'
import { PieChartItem } from '../../charts/pie-chart/interfaces/pie-chart-item'
import { IncentiveFamilyService } from '../../../shared/services/incentive-family.service'

@Component({
  selector: 'app-aggregation-widget',
  templateUrl: './aggregation-widget.component.html',
  styleUrls: ['./aggregation-widget.component.scss']
})
export class AggregationWidgetComponent implements OnChanges {
  @Input() aggregations: Aggregation[]
  @Input() loading: boolean
  @Input() layout: 'tabs' | 'list' | 'overview' = 'tabs'
  @Input() showFamilyTabs = true;

  selectedAggregation: Aggregation
  selectedOverviewAggregation: Aggregation

  @Input() selectedFamily = IncentiveFamily.RDTAX;
  selectedOverview = 'crossCountryOverview';

  families = this.incentiveFamilyService.families;

  constructor(private incentiveFamilyService: IncentiveFamilyService) {}

  overviews = [
    {
      id: 'countryCounts',
      label: 'Cross-country overview'
    },
    {
      id: 'summaryOverview',
      label: 'Summary overview of tax incentives within countries'
    }
  ];
  filteredAggregations: Aggregation[] = [];
  overviewAggregations: Aggregation[] = [];

  private readonly EXCLUDED_AGGREGATION_IDS = [
    'summaryOverview',
    'countryCounts',
    'governmentTaxSupportCombined'
  ];
  protected selectedCountries: string[] = []
  protected selectedIncentiveType: string = 'Both'

  ngOnChanges(): void {
    if (this.aggregations && this.layout === 'tabs') {
      this.aggregations = this.aggregations.filter(
        aggregation => !this.EXCLUDED_AGGREGATION_IDS.includes(aggregation?.id)
      );

      this.changeFamily(this.selectedFamily);
    }

    if (this.aggregations && this.layout === 'overview') {
      this.overviewAggregations = [
        this.aggregations.find(a => a.id === 'summaryOverview'),
        this.aggregations.find(a => a.id === 'countryCounts')
      ].filter(Boolean);

      this.changeOverview('countryCounts');
    }
  }
  filterAggregations(family: IncentiveFamily) {

    this.filteredAggregations = this.aggregations.filter(a =>
      !a?.tab || a.tab.includes(family)
    );

    this.selectedAggregation = this.filteredAggregations[0];
  }

  changeFamily(family: IncentiveFamily) {
    this.selectedFamily = family;
    this.filterAggregations(family);
  }

  changeOverview(overview: string) {
    this.selectedOverview = overview;
    this.selectedOverviewAggregation = this.overviewAggregations.find(a => a.id === overview);
  }

  protected onPieSliceClick($event: PieChartItem) {
    this.changeOverview('summaryOverview');
    this.selectedCountries = $event.countries;
    if ($event.label === "Expenditure-based tax incentives only") {
      this.selectedIncentiveType = "Expenditure-based";
    } else if ($event.label === "Income-based tax incentives only") {
      this.selectedIncentiveType = "Income-based";
    } else {
      this.selectedIncentiveType = "Both";
    }
  }
}
